<template>
  <v-row v-if="$te(disclaimerKey)" class="mt-2">
    <v-col cols="auto ml-3">
      <v-img contain max-width="56" max-height="56" :src="$asset('img/icons/register.svg')" />
    </v-col>
    <v-col class="ml-2">
      <i18n :path="`${disclaimerKey}.${isB2bUser ? 'b2b' : 'b2c'}`">
        <template #disclaimerLink>
          <a
            v-if="!isMobileApp && disclaimerRoute !== 'questions'"
            :href="$localePath(disclaimerRoute)"
            target="_blank"
            data-cy="ePrescriptionDisclaimerLink"
            class="link--inline black--text"
          >
            {{ $t(`ePrescription.${context}DisclaimerLink`) }}
          </a>
          <router-link v-else :to="$localePath(disclaimerRoute)" class="link--inline black--text">
            {{ $t(`ePrescription.${context}DisclaimerLink`) }}
          </router-link>
        </template>
      </i18n>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';

const props = defineProps<{ context?: 'question' | 'order' }>();
const context = computed(() => props.context ?? 'question');

const instance = getCurrentInstance()!.proxy;
const isB2bUser = computed(() => !!instance.$auth?.user?.benefit?.partnerUrl);
const disclaimerKey = computed(() => `ePrescription.${context.value}Disclaimer`);
const disclaimerRoute = computed(() =>
  context.value === 'question' ? 'ePrescription' : 'questions'
);
</script>
